import React from 'react';
import './ImageContainer.scss';

export default function ImageContainer({image}) {
    return <div className={'img-container ' + image}>
        <img src={process.env.PUBLIC_URL + '/images/' + image + '.jpg'} alt={image} />
    </div>
}